import React from 'react';

// Components
import StyledButton from '../../../../../../../components/buttons/StyledButton';

// Utils
import { canEditPermissions, isOwner } from '../../../../../../../../common/permissions/permissionUtil';

// Types
import { MNElement } from '../../../../../../../../common/elements/elementModelTypes';
import { MNUser } from '../../../../../../../../common/users/userModelTypes';
import BoardEditorPermissionPopupDescription from '../editorPermissionPopup/BoardEditorPermissionPopupDescription';

type MobileBoardEditorPermissionInfoProps = {
    editable: boolean;
    permission: number;
    sharedBoard: MNElement | undefined;
    user: MNUser;
    userPermissions: number;
    navigateToSharedBoard: () => void;
    dispatchCloseSheet: () => void;
    closeMobileSharingSheet: () => void;
};

const MobileBoardPermissionSheetInfo = ({
    editable,
    permission,
    sharedBoard,
    user,
    userPermissions,
    navigateToSharedBoard,
    dispatchCloseSheet,
    closeMobileSharingSheet,
}: MobileBoardEditorPermissionInfoProps) => {
    let permissionText = '';
    let handleClick = undefined;

    // Case 1: No permission to edit
    if (!canEditPermissions(userPermissions)) {
        permissionText = "You don't have permission to change the access of other users";
    }
    // Case 2: Is owner
    else if (isOwner(permission)) {
        permissionText = "Make someone else the owner to change this person's access";
    }
    // Case 3: Not editable
    else if (!editable) {
        permissionText = 'Go to that board';
        handleClick = () => {
            dispatchCloseSheet();
            closeMobileSharingSheet();
            navigateToSharedBoard();
        };
    }

    if (!permissionText) {
        return null;
    }

    return (
        <div className="permission-message-container">
            <BoardEditorPermissionPopupDescription
                editable={editable}
                permission={permission}
                sharedBoard={sharedBoard}
                user={user}
            />
            {handleClick ? (
                <StyledButton className="primary thin" onClick={handleClick}>
                    {permissionText}
                </StyledButton>
            ) : (
                <>
                    <div className="permission-message">{permissionText}</div>
                    <StyledButton className="primary thin" onClick={dispatchCloseSheet}>
                        OK
                    </StyledButton>
                </>
            )}
        </div>
    );
};

export default MobileBoardPermissionSheetInfo;
